// src/config/env.config.ts
interface EnvConfig {
  api: {
    url: string;
    auth: string;
    redirect: string;
    endpoints: {
      uploadSignedUrl: string;
      diff: string;
      authRefresh: string;
      convert: string;
      process_p7m: string;
      docSimilarityJob: string;      // New: POST /api/v0/doc-similarity
      jobStatus: string;             // New: GET /api/v0/job
      downloadSignedUrl: string;     // New: POST /download-signed-url
    };
  };
  storage: {
    pdfBucketName: string;    // for leopoldo_bucket
    compareBucketName: string; // for docompare_bucket
    p7mBucketName: string;    // for p7m_bucket
  };
  auth: {
    clientId: string;
    entraClientId: string;
    entraAuthorizeUrl: string;
  };
  sentry?: {
    authToken?: string;
  };
}

const getEnvVar = (key: string): string => {
  const value = process.env[key];
  if (!value) {
    throw new Error(`Environment variable ${key} is not defined`);
  }
  return value;
};

export const config: EnvConfig = {
  api: {
    url: getEnvVar('REACT_APP_URL_API'),
    auth: getEnvVar('REACT_APP_AUTH_API'),
    redirect: getEnvVar('REACT_APP_REDIRECT_URL'),
    endpoints: {
      uploadSignedUrl: getEnvVar('REACT_APP_UPLOAD_SIGNED_URL_ENDPOINT'),
      diff: getEnvVar('REACT_APP_DIFF_ENDPOINT'),
      authRefresh: getEnvVar('REACT_APP_AUTH_API_REFRESH'),
      convert: getEnvVar('REACT_APP_CONVERT_ENDPOINT'),
      process_p7m: getEnvVar('REACT_APP_P7M_ENDPOINT'),
      docSimilarityJob: getEnvVar('REACT_APP_DOC_SIMILARITY_ENDPOINT'),
      jobStatus: getEnvVar('REACT_APP_JOB_STATUS_ENDPOINT'),
      downloadSignedUrl: getEnvVar('REACT_APP_DOWNLOAD_SIGNED_URL_ENDPOINT')
    }
  },
  storage: {
    pdfBucketName: getEnvVar('REACT_APP_PDF_BUCKET_NAME'),
    compareBucketName: getEnvVar('REACT_APP_COMPARE_BUCKET_NAME'),
    p7mBucketName: getEnvVar('REACT_APP_P7M_BUCKET_NAME')
  },
  auth: {
    clientId: `urn:tool_pdf_IT:${getEnvVar('REACT_APP_CLIENT_ID_ENVIRONMENT')}`,
    entraClientId: getEnvVar('REACT_APP_ENTRA_CLIENT_ID'),
    entraAuthorizeUrl: getEnvVar('REACT_APP_ENTRA_AUTHORIZE_URL'),
  }
};
